import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/system';

const whiteLogos = [
  'https://cdn.brandfetch.io/idBW7ugUON/w/548/h/182/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B'
  //https://tukuz.com/wp-content/uploads/2020/10/royal-college-of-general-practitioners-rcgp-logo-vector.png
];

const darkLogos = [
  'https://cdn.brandfetch.io/idBW7ugUON/w/548/h/182/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B'
  //https://tukuz.com/wp-content/uploads/2020/10/royal-college-of-general-practitioners-rcgp-logo-vector.png
];

const logoStyle = {
  width: 'auto',
  height: '120px',
  margin: '10px 32px',
  opacity: 1
};

export default function LogoCollection() {
  const theme = useTheme();
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  return (
    <Box id="logoCollection" sx={{ py: 0 }}>
      <Typography component="p" variant="subtitle1" align="center" color="text.secondary">
        In preparation for the exam set by the
      </Typography>
      <Grid container justifyContent="center" sx={{ mt: 0.5, opacity: 1 }}>
        {logos.map((logo, index) => (
          <Grid item key={index}>
            <img src={logo} alt={`Fake company number ${index + 1}`} style={logoStyle} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
